import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardState } from '../../../games/models/game-view.model';

@Component({
    selector: 'app-card-message',
    imports: [CommonModule],
    templateUrl: './card-message.component.html',
    styleUrl: './card-message.component.scss'
})
export class CardMessageComponent {
    @Input()
    cardState!: CardState;

    @Input()
    textOnly = false;

    @Input()
    back = false;

    @Input()
    compact = false;

    @Input()
    muted = false;

    protected readonly CardState = CardState;
}
